module.exports = __webpack_public_path__ + "img/c01_unitpalintonon_Normal_ua.2c50c094.webp";